module.exports = __webpack_public_path__ + "static/media/pha-logo-white.dcaacddb.png";